import { setLoadingUnique } from 'actions';
import * as productsApi from 'api/products';
import { handleError } from 'services/ErrorService/ErrorService';
import { setProductsList } from './OrdersSearchActions';

export const getProducts = (options) => async (dispatch) => {
  const { sku, simplrAccountId, shopName } = options;

  const params = {
    sku,
    simplrAccountId,
    shopName,
  };

  try {
    dispatch(setLoadingUnique(true, 'searchPage'));
    const productsResponse = await productsApi.getProducts(params);
    dispatch(setProductsList(productsResponse.products));
  } catch (error) {
    handleError({ error, customMessage: 'Something went wrong while grabbing the products', showPopup: true });
  } finally {
    dispatch(setLoadingUnique(false, 'searchPage'));
  }
};
